import Error from './Error';
import NotFound from './NotFound';
import NotAuthorized from './NotAuthorized';

export { Error, NotFound, NotAuthorized };
export default { Error, NotFound, NotAuthorized };
